import * as React from 'react';
const SvgDatabase = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.6 5.2c0-.552.252-1.035.619-1.424.364-.386.863-.706 1.434-.962C6.796 2.302 8.333 2 10 2c1.666 0 3.203.302 4.346.814.571.256 1.07.576 1.434.962.367.39.62.872.62 1.424v9.6c0 .552-.253 1.035-.62 1.424-.364.386-.863.706-1.434.962-1.143.512-2.68.814-4.346.814s-3.204-.302-4.347-.814c-.571-.256-1.07-.576-1.434-.962-.367-.39-.62-.872-.62-1.424zm1.2 0c0 .166.072.367.292.6.223.236.573.476 1.052.691C7.1 6.919 8.462 7.2 10 7.2s2.9-.28 3.855-.709c.479-.215.83-.455 1.052-.69.22-.234.293-.435.293-.601s-.073-.367-.293-.6c-.222-.236-.573-.476-1.052-.691C12.9 3.481 11.537 3.2 10 3.2c-1.538 0-2.9.28-3.856.709-.479.215-.83.455-1.052.69-.22.234-.292.435-.292.601m10.4 1.914a5.4 5.4 0 0 1-.854.472c-1.143.512-2.68.814-4.346.814s-3.204-.302-4.347-.814a5.4 5.4 0 0 1-.853-.472V14.8c0 .165.072.367.292.6.223.236.573.476 1.052.691.956.428 2.318.709 3.856.709s2.9-.28 3.855-.709c.479-.215.83-.455 1.052-.69.22-.234.293-.435.293-.601z"
    />
  </svg>
);
export default SvgDatabase;
